import { SampleCalcs } from '../models/calculate.model';
import { SampleSummaryResult } from '../models/result.model';

export interface RerunSummary {
  rerunSamples: number;
  assayResultsAffected: number;
  replicates: number;
  discarded: number;
}

/**
 * A sample is a rerun when the instrument's replicate numbering restarts partway through its
 * replicates (updatedRepNum 1..n stays sequential while repNum goes 1,2,1,2,3,4). A constant
 * repNum (1,1) is a different layout, not a restart.
 */
export function isRerunSample(sample: SampleSummaryResult): boolean {
  const reps = [...(sample.individualReps ?? [])].sort((a, b) => a.updatedRepNum - b.updatedRepNum);
  return reps.some((rep, index) => index > 0 && rep.repNum < reps[index - 1].repNum);
}

export function rerunSamples(samples: SampleSummaryResult[]): SampleSummaryResult[] {
  return samples.filter(isRerunSample);
}

/** Row-level counts for the Rerun Samples summary tiles. */
export function summarizeReruns(rows: SampleCalcs[]): RerunSummary {
  const accessions = new Set<string>();
  const assayResults = new Set<string>();
  rows.forEach(row => {
    accessions.add(row.accessionId ?? '');
    assayResults.add(`${row.reportContentItemId ?? ''}|${row.accessionId ?? ''}`);
  });
  return {
    rerunSamples: accessions.size,
    assayResultsAffected: assayResults.size,
    replicates: rows.length,
    discarded: rows.filter(row => row.isDiscarded).length
  };
}
